import React from 'react';
import { TemplateType } from '@frontend/app/types/globalTypes';
import { H3 } from '@frontend/shadcn/components/typography/h3';
import { template } from 'lodash';
import { useProjectByIdQuery } from '@frontend/app/hooks';
import { useAuth } from '@frontend/context/authContext';
import { useGetDefaultMemberFieldSchemasQuery } from '@frontend/app/hooks/useGetDefaultMemberFieldSchemasQuery';
import { useSaveProgramMutation } from '@frontend/app/containers/Communities/AddOrEditCommunity/hooks/useSaveProgramMutation';
import { useMessagingContext } from '@frontend/hooks';
import { logger } from '@common';
import { DEFAULT_INVITE_EMAIL_TEMPLATE } from './DefaultInviteEmailTemplate';
import { EmailTemplates } from '../../components/EmailTemplates';

interface InviteEmailTemplateProps {
  projectId: number;
}
export const InviteEmailTemplate = (props: InviteEmailTemplateProps) => {
  const { projectId } = props;

  const { data: project } = useProjectByIdQuery({
    variables: {
      id: projectId,
    },
    fetchPolicy: 'cache-first',
  });

  const { clientInfo } = useAuth();

  const { defaultMemberFieldSchemas } = useGetDefaultMemberFieldSchemasQuery();

  const [saveProgram] = useSaveProgramMutation(project?.project?.communityId);

  const { showErrorMessage } = useMessagingContext();

  const firstNameSchema = defaultMemberFieldSchemas?.find((schema) => schema.name === 'First Name');

  const defaultEmailTitle = project?.project ? template(DEFAULT_INVITE_EMAIL_TEMPLATE.title)({ program: project.project }) : '';
  const defaultEmailSubject = clientInfo ? template(DEFAULT_INVITE_EMAIL_TEMPLATE.subject)({ client: clientInfo }) : '';
  const defaultEmailText = firstNameSchema ? template(DEFAULT_INVITE_EMAIL_TEMPLATE.text)({ id: firstNameSchema.id }) : '';

  const handleMakeDefault = async (templateId: number) => {
    await saveProgram({
      variables: {
        program: { id: projectId, emailTemplateId: templateId },
      },
      onError: (error) => {
        logger.error('InviteEmailTemplate.handleMakeDefault', error);
        showErrorMessage(error.message || 'Failed to make template default');
      },
    });
  };

  return (
    <div className="w-full p-6 flex flex-col gap-2">
      <H3 className="m-0 font-medium text-lg">Recruiting</H3>
      <EmailTemplates
        projectId={projectId}
        templateType={TemplateType.INVITE}
        title="Invite Email Template"
        description="Set and customize your email template for all creators that are sent an invitation to apply."
        defaultTemplateId={project?.project?.emailTemplateId}
        defaultEmailTitle={defaultEmailTitle}
        defaultEmailSubject={defaultEmailSubject}
        defaultEmailText={defaultEmailText}
        handleMakeDefault={handleMakeDefault}
      />
    </div>
  );
};
